import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const TrendAnalysisListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Analysis Date', value: (item) => fmtDate(item.analysis_date) },
    { label: 'Description', value: 'description' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/trend/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['trendAnalysis']} />;
};

export default TrendAnalysisListDetails;